import styled from "styled-components";
import {
  animationDuration,
  breakpoints,
  zIndex,
} from "../../../NavigationBar/theme";
export const wrapperMaxHeight = 420;
export const searchBarHeight = 54;
export const searchWrapperMaxHeight = wrapperMaxHeight - searchBarHeight;
export const itemHeight = 43;
export const wrapperPadding = 8;

export const StyledSearchResultWrapper = styled.div`
  @media screen and (min-width: ${breakpoints.tablet}px) {
    min-width: 400px;
  }

  background-color: rgb(255 255 255 / 100%);
  height: 100%;
  transition: opacity ${animationDuration.fast}ms ease-in-out;
  opacity: 0;
  z-index: ${zIndex.under};
  padding: 0 0 ${wrapperPadding}px 0;

  &.enter-active {
    opacity: 0;
    z-index: 0;
  }

  &.enter-done {
    opacity: 1;
    z-index: 0;
  }

  &.exit-active {
    opacity: 0;
    z-index: ${zIndex.under};
  }
`;

export const StyledSearchPlaceholder = styled.div<{
  hidePlaceholder: boolean;
}>`
  display: ${({ hidePlaceholder }) => (hidePlaceholder ? "none" : "block")};
  margin: 32px auto;
  width: 124px;
  height: 112px;

  > img {
    width: 100%;
    height: auto;
  }
`;

export const StyledSearchResultItem = styled.div`
  padding: 8px;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  border-radius: 8px;
  cursor: pointer;
  color: #595959;
  margin: 4px 8px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  &:hover {
    background-color: rgb(248 248 248 / 100%);
  }

  b {
    font-weight: 500;
    color: #000;
  }

  .divider {
    color: rgb(146 146 146 / 100%);
  }
`;
